export enum CurrentPlanRanking {
  TOP_PLAN_IN_REC = 'TOP_PLAN_IN_REC',
  NOT_IN_REC = 'NOT_IN_REC',
  IN_REC = 'IN_REC',
}
